class ProductTabs extends HTMLElement {
  constructor() {
    super();
  }
  update(variant) {
    const variant_id = new String(variant?.id);
    if(variant_id) {
      const fetchURL = new URL(location);
      fetchURL.searchParams.set('variant', variant_id);
      fetchURL.searchParams.set('section_id', 'product-tabs');
      fetch(fetchURL)
      .then(response => response.text())
      .then(response => {
        const template = document.createElement('template');
        template.innerHTML = response.trim();
        const old_inputs = this.querySelectorAll('input');
        old_inputs.forEach(input => {
          const new_input = template.content.querySelector(`product-tabs input#${input.id}`);
          if(!!new_input) {
            new_input.checked = input.checked;
          }
        });
        let updated_component = template.content.querySelector('product-tabs');
        this.replaceWith(updated_component);
      })
      .catch(error => console.error(error));
    }
  }
}
customElements.define("product-tabs", ProductTabs);